import * as Yup from "yup";

const Validation = Yup.object({
  titles: Yup.string().required("Please enter title!"),
  description: Yup.string().required("Please enter description!"),
  name: Yup.string().required("Please enter name!"),
  image: Yup.string().required("Please enter image!"),
  tokenPrice: Yup.string().required("Please enter token price!"),
  giftType: Yup.string().required("Please enter gift type!"),
  prompts: Yup.string().required("Please enter prompt!"),
});

export default Validation;
